module.exports = __webpack_public_path__ + "img/Differentiation-BLCA_GSE171351.9fc2c6c2.png";